import React, { useContext } from "react";
import { CallToActionContext } from "../../contexts/CallToActionContext";
import BookTaxiDialogue from "./TaxiBookingCreation/BookTaxiDialogue";


export default function CallsToAction(){
    const context = useContext(CallToActionContext);

    const {
        showTaxiBookingDialogue=false,
        showPassBookingDialogue=false
    } = context;


    return (
        <>
            {showTaxiBookingDialogue &&
                <BookTaxiDialogue
                    showDialogue={showTaxiBookingDialogue} 
                    setShowDialogue={(newState)=>{context.setState({showTaxiBookingDialogue:newState})}}
                />
            }
            {showPassBookingDialogue &&
                <>Should show the book taxi dialogue</>
            }
        </>
    );


}